import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import classnames from 'classnames'

import {
  fetchNotifications
} from '../actions/notifications'

import {
  removeUserSession
} from '../actions/user-session'

class User extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false,
      showNotificationsDropdown: false
    }
  }

  componentWillMount() {
    this.props.fetchNotifications()
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { notifications, userSession } = nextProps

    if (notifications !== this.props.notifications) return true
    if (userSession !== this.props.userSession) return true
    if (nextState !== this.state) return true
    return false
  }

  removeUserSession() {
    this.props.removeUserSession(false)
    this.props.history.replace({pathname: '/'})
  }

  renderDropdown() {
    const { userSession } = this.props
    const { user } = userSession
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--main': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li>{user && user.email}</li>
              <li onClick={() => this.setState({showDropdown: false}, () => this.removeUserSession())}>Log out</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderNotificationsDropdown() {
    const { notifications, userSession } = this.props
    const { user } = userSession
    const { showNotificationsDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--notifications': true,
      'ui-dropdown--active': showNotificationsDropdown
    })

    return (
      <div className={className}>
        {showNotificationsDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showNotificationsDropdown: !showNotificationsDropdown})} /> : null}

        <div className="ui-dropdown-value" onClick={() => this.setState({showNotificationsDropdown: !showNotificationsDropdown})}>
          {notifications.total_unseen}
        </div>

        {
          showNotificationsDropdown === true
          ? <ul className="ui-dropdown-content">
              {/*<li>{user && user.email}</li>*/}
              <li className="logout" onClick={() => this.setState({showNotificationsDropdown: false}, () => this.removeUserSession())}>Log out</li>

              <h3>Recent notifications ({notifications.items.length}/{notifications.total_unseen})</h3>

              {
                notifications.items.length > 0
                ? notifications.items.map((notification, index) => {
                    return (
                      <li key={index}>
                        {/*<h3>{notification.title}</h3>*/}
                        <small>{notification.title}</small>
                      </li>
                    )
                  })
                : null
              }
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { notifications, userSession } = this.props
    const { user } = userSession

    return (
      <div className="user">
        <span onClick={() => this.setState({showNotificationsDropdown: true})}>
          {user && user.email}
        </span>

        {
          Object.keys(notifications).length > 0 && notifications.isFetching !== true
          ? this.renderNotificationsDropdown()
          : null
        }

        {this.renderDropdown()}
      </div>
    )
  }
}

User.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  notifications: PropTypes.object,
  fetchNotifications: PropTypes.func,
  userSession: PropTypes.object,
  removeUserSession: PropTypes.func
}

User.defaultProps = {
  match: {},
  location: {},
  history: {},
  notifications: {},
  fetchNotifications: function() {},
  userSession: {},
  removeUserSession: function() {}
}

export const mapStateToProps = (state) => {
  return {
    notifications: state.notifications,
    userSession: state.userSession
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchNotifications,
    removeUserSession
  }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(User))



// WEBPACK FOOTER //
// ./src/containers/user.js